import React from "react";
import Icons8Sun from "../Assets/images/icons8-sun.svg";
import FoundationLogo from "../Assets/images/foundation-nft-logo.svg";
import FoundationLogoWhite from "../Assets/images/foundation-nft-logo-white.svg";
import FoundationMobilLogo from "../Assets/images/mobile_logo.svg";
import { ConnectButton } from "@rainbow-me/rainbowkit";
import { Outlet, Link } from "react-router-dom";

class Navbar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  handleModeTrigger = (event) => {
    this.props.modeChange(event);
    event.preventDefault();
  };

  render() {
    return (
      <div>
        <nav className="navbar navbar-expand-sm">
          <a href={"/"} className="navbar-brand header-logo">
            <img
              src={FoundationLogo}
              alt="FoundationLogo"
              className="large-icon dark-theme deskTopOnly"
            />
            <img
              src={FoundationLogoWhite}
              alt="FoundationLogo"
              className="white-theme deskTopOnly"
            />
            <img
              src={FoundationMobilLogo}
              alt="FoundationLogo"
              className="large-icon mobileOnly"
            />
          </a>

          {/* <button className="navbar-toggler navbar-toggler-right" type="button" data-toggle="collapse" data-target="#navb">
                            Menu
                        </button> */}

          <ul
            className="navbar-nav ml-auto navbar-nav navbar-navRight "
            id="navb"
          >
            <li className="nav-item menu pr-3">
              <a href={"/getnfts"}>Get Nfts</a>
            </li>
            <li className="nav-item">
              <ConnectButton
                type="button"
                className="btn-green"
              ></ConnectButton>
            </li>
            <li className="nav-item">
              <button
                type="button"
                className="btn btnIc"
                onClick={this.handleModeTrigger}
              >
                <img src={Icons8Sun} alt="Icons8Sun" />
              </button>
            </li>
          </ul>
        </nav>
        <Outlet />
      </div>
    );
  }
}

export default Navbar;
